import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const SEOMetaDescription = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12698"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12698)">
          <rect
            x="-4"
            y="-3"
            width="121"
            height="118"
            rx="5.61291"
            fill="#FFEDBF"
          />
          <path
            d="M88.4514 35.4285V86.6316C88.4514 88.3291 87.7771 89.957 86.5768 91.1574C85.3765 92.3577 83.7485 93.032 82.051 93.032H21.2473C19.5498 93.032 17.9219 92.3577 16.7216 91.1574C15.5212 89.957 14.8469 88.3291 14.8469 86.6316V35.4285H88.4514Z"
            fill="#66E1FF"
          />
          <path
            d="M14.8469 35.4285V86.6316C14.8469 88.3291 15.5212 89.957 16.7216 91.1574C17.9219 92.3577 19.5498 93.032 21.2473 93.032H24.4475L82.051 35.4285H14.8469Z"
            fill="#C2F3FF"
          />
          <path
            d="M88.4514 35.4285H14.8469V25.8279C14.8469 24.1304 15.5212 22.5024 16.7216 21.3021C17.9219 20.1018 19.5498 19.4275 21.2473 19.4275H82.051C83.7485 19.4275 85.3765 20.1018 86.5768 21.3021C87.7771 22.5024 88.4514 24.1304 88.4514 25.8279V35.4285Z"
            fill="white"
          />
          <path
            d="M82.051 19.4275H21.2473C19.5498 19.4275 17.9219 20.1018 16.7216 21.3021C15.5212 22.5024 14.8469 24.1304 14.8469 25.8279V86.6316C14.8469 88.3291 15.5212 89.9571 16.7216 91.1574C17.9219 92.3577 19.5498 93.032 21.2473 93.032H82.051C83.7485 93.032 85.3765 92.3577 86.5768 91.1574C87.7771 89.9571 88.4514 88.3291 88.4514 86.6316V25.8279C88.4514 24.1304 87.7771 22.5024 86.5768 21.3021C85.3765 20.1018 83.7485 19.4275 82.051 19.4275Z"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.8469 35.4285H88.4514"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.0476 28.228C25.8354 28.228 25.6319 28.1437 25.4819 27.9937C25.3318 27.8437 25.2476 27.6402 25.2476 27.428C25.2476 27.2158 25.3318 27.0123 25.4819 26.8623C25.6319 26.7122 25.8354 26.6279 26.0476 26.6279"
            stroke="#191919"
            strokeWidth="1.05242"
          />
          <path
            d="M26.0476 28.228C26.2598 28.228 26.4633 28.1437 26.6133 27.9937C26.7634 27.8437 26.8477 27.6402 26.8477 27.428C26.8477 27.2158 26.7634 27.0123 26.6133 26.8623C26.4633 26.7122 26.2598 26.6279 26.0476 26.6279"
            stroke="#191919"
            strokeWidth="1.05242"
          />
          <path
            d="M35.6482 28.228C35.436 28.228 35.2325 28.1437 35.0825 27.9937C34.9324 27.8437 34.8481 27.6402 34.8481 27.428C34.8481 27.2158 34.9324 27.0123 35.0825 26.8623C35.2325 26.7122 35.436 26.6279 35.6482 26.6279"
            stroke="#191919"
            strokeWidth="1.05242"
          />
          <path
            d="M35.6482 28.228C35.8604 28.228 36.0639 28.1437 36.2139 27.9937C36.364 27.8437 36.4482 27.6402 36.4482 27.428C36.4482 27.2158 36.364 27.0123 36.2139 26.8623C36.0639 26.7122 35.8604 26.6279 35.6482 26.6279"
            stroke="#191919"
            strokeWidth="1.05242"
          />
          <path
            d="M45.2488 28.228C45.0366 28.228 44.8331 28.1437 44.6831 27.9937C44.533 27.8437 44.4487 27.6402 44.4487 27.428C44.4487 27.2158 44.533 27.0123 44.6831 26.8623C44.8331 26.7122 45.0366 26.6279 45.2488 26.6279"
            stroke="#191919"
            strokeWidth="1.05242"
          />
          <path
            d="M45.2488 28.228C45.461 28.228 45.6645 28.1437 45.8145 27.9937C45.9645 27.8437 46.0488 27.6402 46.0488 27.428C46.0488 27.2158 45.9645 27.0123 45.8145 26.8623C45.6645 26.7122 45.461 26.6279 45.2488 26.6279"
            stroke="#191919"
            strokeWidth="1.05242"
          />
          <circle
            cx="26.0403"
            cy="42.2671"
            r="2.28024"
            fill="#191919"
            stroke="black"
            strokeWidth="1.05242"
          />
          <path
            d="M25.3386 50.6863H70.9435"
            stroke="#191919"
            strokeWidth="2.80645"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.3386 56.2992H59.1184"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.3386 61.0713H52.1445"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.6564 65.7019H67.9529C65.025 65.7019 62.2169 66.865 60.1466 68.9354C58.0762 71.0058 56.9131 73.8138 56.9131 76.7417C56.9131 79.6696 58.0762 82.4777 60.1466 84.548C62.2169 86.6184 65.025 87.7815 67.9529 87.7815H96.6564C99.5843 87.7815 102.392 86.6184 104.463 84.548C106.533 82.4777 107.696 79.6696 107.696 76.7417C107.696 73.8138 106.533 71.0058 104.463 68.9354C102.392 66.865 99.5843 65.7019 96.6564 65.7019Z"
            fill="#C2F3FF"
          />
          <path
            d="M67.9529 71.2216H96.6564C99.1041 71.2212 101.483 72.0343 103.418 73.5331C105.353 75.0319 106.735 77.1314 107.347 79.5014C107.769 77.8699 107.811 76.1636 107.471 74.5133C107.131 72.8629 106.417 71.3124 105.385 69.9803C104.353 68.6483 103.03 67.5701 101.517 66.8285C100.004 66.0869 98.3414 65.7014 96.6564 65.7017H67.9529C66.2679 65.7014 64.6052 66.0869 63.0921 66.8285C61.5791 67.5701 60.2559 68.6483 59.224 69.9803C58.192 71.3124 57.4787 72.8629 57.1386 74.5133C56.7985 76.1636 56.8407 77.8699 57.2619 79.5014C57.8739 77.1314 59.2561 75.0319 61.1914 73.5331C63.1266 72.0343 65.5051 71.2212 67.9529 71.2216Z"
            fill="#66E1FF"
          />
          <path
            d="M96.6564 65.7019H67.9529C65.025 65.7019 62.2169 66.865 60.1466 68.9354C58.0762 71.0058 56.9131 73.8138 56.9131 76.7417C56.9131 79.6696 58.0762 82.4777 60.1466 84.548C62.2169 86.6184 65.025 87.7815 67.9529 87.7815H96.6564C99.5843 87.7815 102.392 86.6184 104.463 84.548C106.533 82.4777 107.696 79.6696 107.696 76.7417C107.696 73.8138 106.533 71.0058 104.463 68.9354C102.392 66.865 99.5843 65.7019 96.6564 65.7019Z"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.3927 81.4619C93.8971 81.4619 95.3398 80.8643 96.4036 79.8006C97.4674 78.7368 98.065 77.2941 98.065 75.7897C98.065 74.2853 97.4674 72.8425 96.4036 71.7788C95.3398 70.715 93.8971 70.1174 92.3927 70.1174C90.8883 70.1174 89.4456 70.715 88.3818 71.7788C87.3181 72.8425 86.7205 74.2853 86.7205 75.7897C86.7205 77.2941 87.3181 78.7368 88.3818 79.8006C89.4456 80.8643 90.8883 81.4619 92.3927 81.4619Z"
            fill="#E4F1F5"
          />
          <path
            d="M88.3811 79.7993C87.3313 78.7327 86.7456 77.2945 86.7515 75.7979C86.7575 74.3014 87.3546 72.8678 88.4128 71.8096C89.4711 70.7513 90.9046 70.1542 92.4012 70.1482C93.8977 70.1423 95.336 70.728 96.4026 71.7778L88.3811 79.7993Z"
            fill="white"
          />
          <path
            d="M96.4023 79.7994L99.9682 83.3653"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.3927 81.4619C93.8971 81.4619 95.3398 80.8643 96.4036 79.8006C97.4674 78.7368 98.065 77.2941 98.065 75.7897C98.065 74.2853 97.4674 72.8425 96.4036 71.7788C95.3398 70.715 93.8971 70.1174 92.3927 70.1174C90.8883 70.1174 89.4456 70.715 88.3818 71.7788C87.3181 72.8425 86.7205 74.2853 86.7205 75.7897C86.7205 77.2941 87.3181 78.7368 88.3818 79.8006C89.4456 80.8643 90.8883 81.4619 92.3927 81.4619Z"
            stroke="#191919"
            strokeWidth="1.05242"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip0_1529_12698)">
            <path
              d="M75.0131 77.0736C75.0131 76.6175 74.9721 76.179 74.8961 75.7581H68.8389V78.2488H72.3002C72.1481 79.0498 71.6921 79.728 71.008 80.1841V81.8036H73.0953C74.3114 80.681 75.0131 79.0322 75.0131 77.0736Z"
              fill="#4285F4"
            />
            <path
              d="M68.8389 83.3588C70.5754 83.3588 72.0313 82.7858 73.0954 81.8035L71.0081 80.184C70.4351 80.5699 69.7043 80.8037 68.8389 80.8037C67.1668 80.8037 65.746 79.6753 65.2373 78.1552H63.0974V79.8156C64.1557 81.9146 66.3248 83.3588 68.8389 83.3588Z"
              fill="#34A853"
            />
            <path
              d="M65.2373 78.1495C65.1087 77.7636 65.0327 77.3543 65.0327 76.9275C65.0327 76.5007 65.1087 76.0914 65.2373 75.7055V74.045H63.0974C62.6589 74.9104 62.4075 75.8868 62.4075 76.9275C62.4075 77.9682 62.6589 78.9446 63.0974 79.81L64.7637 78.512L65.2373 78.1495Z"
              fill="#FBBC05"
            />
            <path
              d="M68.8389 73.0567C69.7861 73.0567 70.6281 73.3842 71.3004 74.0156L73.1422 72.1739C72.0254 71.1331 70.5754 70.4958 68.8389 70.4958C66.3248 70.4958 64.1557 71.94 63.0974 74.0448L65.2373 75.7053C65.746 74.1852 67.1668 73.0567 68.8389 73.0567Z"
              fill="#EA4335"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12698">
            <rect
              width="14.0323"
              height="14.0323"
              fill="white"
              transform="translate(61.8228 69.9111)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
